import * as types from './mutation-types'

export default {
  [types.SET_CLASS_LIST](state, payload) {
    state.classList = payload
  },
  [types.SET_CURRENT_UNIT](state, payload) {
    state.currentUnit = payload
  },
  [types.SET_CLASS_SCHEDULES_SCHEDULE_LIST](state, payload) {
    state.classSchedulesList = payload
  },
  [types.SET_SCHEDULES_LIST](state, payload) {
    state.schedulesList = payload
  }
}